<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default{
  data() {
    return {
    }
  },

  methods: {
  },

  mounted() {
    const params = new URLSearchParams(window.location.search)

    if (!params.has('token_type')) {
      this.$router.push({ name: 'home' }).catch(() => {})
      return
    }
    
    if (!params.get('token_type') != 'Bearer'){
      this.$router.push({ name: 'home' }).catch(() => {})
      return
    }

    if (!params.has('state')){
      this.$router.push({ name: 'home' }).catch(() => {})
      return
    }

    Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + params.get('state');
    localStorage.setItem('rekom.life.accessToken', params.get('state'));

    this.$router.push({ name: 'home' }).catch(() => {})
  },

  created() {
    this.$vs.loading();
    //const result = this.$msal.signIn();
  },

  destroyed() {
    this.$vs.loading.close();
  }
}
</script>

<style lang="scss">
</style>
